module.exports = __webpack_public_path__ + "static/media/share.a9469b15.svg";